import {
  NOTE_SAVE_HANDLERS,
  useNoteSaveHandlerRegistry,
} from "../../NoteSaveHandlersContext";

const useNoteSaveHandlers = () => {
  const registry = useNoteSaveHandlerRegistry();
  const run = (name, ...args) => registry?.run(name, ...args) ?? false;

  return {
    saveAndArchiveReportNote: () => run(NOTE_SAVE_HANDLERS.REPORT_NOTE_ARCHIVE),
    saveReportNote: () => run(NOTE_SAVE_HANDLERS.REPORT_NOTE_SAVE),
    saveAndProcessReportNote: () =>
      run(NOTE_SAVE_HANDLERS.REPORT_NOTE_SAVE_AND_PROCESS),

    saveAndProcessClinicNote: () =>
      run(NOTE_SAVE_HANDLERS.CLINIC_NOTE_SAVE, true),

    savePhysicianNote: (...args) =>
      run(NOTE_SAVE_HANDLERS.PROVIDER_NOTE_SAVE, ...args) ||
      run(NOTE_SAVE_HANDLERS.CLINIC_NOTE_SAVE, ...args),
  };
};

export default useNoteSaveHandlers;
